<template>
<v-container fluid>
  <data-card color="primary" :title="$tc('report.reportDataImport.title', 2)">
    <div style="background-color: white" class="pa-2">
      {{$t('report.reportDataImport.description')}}
      <br><br>
      <v-btn
        v-if="this.isUserAdministrator"
        :loading="isDataUpdating"
        style="margin-right: 100px"
        @click="confirmReportDataImport"
        >
        {{$t('report.reportDataImport.startImport')}}
        <v-icon right color="red">refresh</v-icon>
      </v-btn>
    </div>
  </data-card>
</v-container>
</template>

<script>
import { Api } from '@/api/apiAccess'
import { mapGetters } from 'vuex'
import { confirmMixin, snackBarMixin, pageTitleMixin } from '@/mixins/mixins'

export default {
  mixins: [
    confirmMixin,
    snackBarMixin,
    pageTitleMixin
  ],
  data () {
    return {
      isDataUpdating: false
    }
  },
  computed: {
    ...mapGetters(['isUserAdministrator'])
  },
  methods: {
    confirmReportDataImport () {
      this.$confirm(this.$t('report.reportDataImport.importReportDataConfirm'), { title: this.$t('report.reportDataImport.importReportData'), focusFalseButton: true })
        .then((r) => {
          if (r) {
            this.importReportData()
          }
        })
    },
    importReportData () {
      this.isDataUpdating = true

      let ep = Api.Report
      ep.reportImportReportDataFromSage()
        .then(r => {
          this.$nextTick(() => {
            this.showStatusMessage(this.$t('report.reportDataImport.importSuccess'))
          })
        })
        .finally(() => {
          this.isDataUpdating = false
        })
    }
  }
}
</script>
